import { render } from "./CreateAlternateOffer.vue?vue&type=template&id=1787a7ce"
import script from "./CreateAlternateOffer.vue?vue&type=script&lang=js"
export * from "./CreateAlternateOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__